import React from 'react';
import PropTypes from 'prop-types';
// MATERIAL-UI
import Link from '@mui/material/Link';
// config
import AppConfig from 'appConfig';
import { moduleConfig, USER_TYPE_ZYWAVE, toBrowserPath } from '../../lib/config/appConstants';
import { hideZuiNavigation } from 'lib/AppHelpers';

class ZuiNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entitledProducts: {},
    };
  }

  render() {
    const { props, state } = this;

    if (!props || !props.userInfo) {
      return null;
    }
    const { entitledProducts } = state;
    const { module, userInfo } = props;

    if (!module && !entitledProducts.EB && !entitledProducts.PAC) {
      return null;
    }

    if (hideZuiNavigation(module)) {
      return <div></div>;
    }

    const userIsEntitled =
      entitledProducts['HWR'] ||
      entitledProducts['RET'] ||
      entitledProducts['HAN'] ||
      entitledProducts['PAC'] ||
      entitledProducts['EB'];

    if (!userIsEntitled) {
      return null;
    }

    const supportCenterUrl = AppConfig.supportCenterURLZywave;

    const zywaveUser = userInfo.account_type === USER_TYPE_ZYWAVE;

    return (
      <zui-shell-nav unresolved>
        <zui-shell-nav-item unresolved subnav>
          <zui-icon unresolved icon="zui-nav-prospecting" slot="icon"></zui-icon>
          Prospecting
          {entitledProducts['EB'] && (
            <Link href={toBrowserPath('/edge' + moduleConfig.EB.home)} underline="hover">
              {moduleConfig.EB.menuName}
            </Link>
          )}
          {entitledProducts['PAC'] && (
            <Link href={toBrowserPath('/edge' + moduleConfig.PC.home)} underline="hover">
              {moduleConfig.PC.menuName}
            </Link>
          )}
          {entitledProducts['HAN'] && (
            <Link href="/app/analytic" target="_blank" underline="hover">
              Analytics
            </Link>
          )}
          {entitledProducts['HWR'] && (
            <Link href="/app/welfare" target="_blank" underline="hover">
              Health and Welfare
            </Link>
          )}
          {entitledProducts['RET'] && (
            <Link href="/app/retirement" target="_blank" underline="hover">
              Retirement
            </Link>
          )}
        </zui-shell-nav-item>
        {supportCenterUrl && !zywaveUser && AppConfig.enableSupportCenterLinks && (
          <zui-shell-nav-item unresolved>
            <zui-icon unresolved icon="zui-nav-help" slot="icon"></zui-icon>
            <a href={supportCenterUrl} target="_blank" rel="noreferrer">
              Support Center
            </a>
          </zui-shell-nav-item>
        )}
      </zui-shell-nav>
    );
  }

  componentDidMount() {
    //lets put the entitlements information into a usable format
    const entitledProducts = {};

    const { userInfo } = this.props;
    if (!userInfo) {
      return null;
    }

    if (userInfo && userInfo.products) {
      userInfo.products.forEach((product) => {
        if (
          Object.prototype.hasOwnProperty.call(product, 'H-W') &&
          userInfo.can_access_legacy_hw_ret === '1'
        ) {
          //Health and Welfare
          entitledProducts['HWR'] = true;
        }
        if (
          Object.prototype.hasOwnProperty.call(product, 'SGR') &&
          userInfo.can_access_legacy_hw_ret === '1'
        ) {
          // Retirement
          entitledProducts['RET'] = true;
        }
        if (Object.prototype.hasOwnProperty.call(product, 'H-W')) {
          // Employee Benefits
          entitledProducts['EB'] = true;
        }
        if (Object.prototype.hasOwnProperty.call(product, 'PC')) {
          // Commercial Lines
          entitledProducts['PAC'] = true;
        }
        if (Object.prototype.hasOwnProperty.call(product, 'A-R')) {
          // Analytics
          entitledProducts['HAN'] = true;
        }
      });
    }

    this.setState({ entitledProducts: entitledProducts });
  }
}

ZuiNavigation.propTypes = {
  module: PropTypes.oneOf([moduleConfig.PC.shortName, moduleConfig.EB.shortName, '']),
  classes: PropTypes.object,
  userInfo: PropTypes.object,
};

export default ZuiNavigation;
